import { Component, EventEmitter } from '@angular/core';

import { Prices } from '@bytel/bytel-sales';

import { ProService } from '@base/services/btl-pro.service';

import { BtlHelperService } from '@app/base/services/btl-helper.service';
import { BytelTagService } from '@app/base/services/bytel-tag.service';
import { UniversalStorageService } from '@app/base/services/universal-storage.service';
import { ApiProduct, CommercialRange } from '@app/baseBtl/catalog/products/interface/context';
import { PLAN_TAG_NAMES } from '@app/catalog/Enum';
import { Catalog } from '@app/catalog/products/catalog';
import { Plan } from '@app/catalog/products/subscription/plan';
import { IPromotions } from '@app/checkout/cart/promotions/promotion.interface';
import { Scheme } from '@app/checkout/cart/scheme.class';
import { ProductContext } from '@app/context/child/product-context.service';
import { ContextService } from '@app/context/context.service';

enum SHOW_DETAILS_CMS {
    ABROAD_DATA = 'showAbroadDataCms',
    INTERNAIONAL_CALLS = 'showInternationalCallsCms',
}

@Component({
    templateUrl: './plan-details-modal.component.html',
    styleUrls: ['./plan-details-modal.component.scss'],
})
export class PlanDetailsModalNewtonComponent {
    public plan: Plan;
    public planRenewInfos: ApiProduct;
    public ctaLabel: string;
    public prices: Prices;
    public isWithoutTax: boolean;
    public hasSpecialStyle: boolean;
    public locked: boolean;
    public wordingIncluded: string;
    public cmsPopin: string;

    public cmsFromAbroad: string;
    public linkWord: string = '120 pays';
    public internationalCallWordings: string[] = [];
    public SHOW_DETAILS_CMS = SHOW_DETAILS_CMS;
    public showAbroadDataCms = false;
    public showInternationalCallsCms = false;
    public onLockAction = new EventEmitter();
    public onAddCart = new EventEmitter();
    public tagValues: { [key: string]: any } = {
        pageCategorie: 'Fiche_produit_mobile',
        etapeEcommerce: 'Fiche_produit',
        ligneMarche: 'Mobile',
    };
    public isRenew: boolean;
    public planUuid: string;
    public cmsInternationalCalls: string;
    public planName: string;
    public finalPrice: number;

    constructor(
        private universalStorage: UniversalStorageService,
        private tagService: BytelTagService,
        private contextService: ContextService,
        private proService: ProService,
        private btlHelper: BtlHelperService,
    ) {}

    ngOnInit() {
        this.updateLockedStatus();
        this.sendTags();

        this.planUuid = this.btlHelper.uuid();
        this.hasSpecialStyle = this.plan.is_darwin;

        const btlId = this.plan.dataEnvelope.replace(/ /g, '_').replace(/à/g, 'a').toLowerCase();
        const planType = this.getPlanType();
        const isPro = this.proService.isOnProWall() || this.plan.data.exclu_pro;
        this.cmsPopin = `mobiles/${this.isRenew && this.plan.data.owned ? 'renouvellement/' : ''}${
            isPro ? 'pro/' : ''
        }${planType}/popin-${btlId}`;
        this.cmsInternationalCalls = `/mobiles/banniere_forfaits-mobiles_destinations${isPro ? '_pro' : ''}`;
        this.cmsFromAbroad = `/mobiles/banniere_forfaits-mobiles_from_aboard${isPro ? '_pro' : ''}`;

        this.internationalCallWordings = this.plan.data.international_call?.split(this.linkWord) || [];

        if (this.hasSpecialStyle) {
            this.wordingIncluded = 'Le forfait qui grandit avec votre ado...';
        } else {
            this.wordingIncluded = this.plan.data?.low_prices_wall
                ? "L'essentiel pour bien communiquer..."
                : 'Le plein de gigas,<br class="is-hidden-tablet" /> mais pas seulement...';
        }
        if (this.isRenew) {
            const { prix, nom } = this.planRenewInfos;
            this.planName = nom || `Forfait ${this.plan.name}`;
            this.finalPrice = prix.final;
        } else {
            this.planName = `Forfait ${this.plan.name}`;
            this.finalPrice = this.prices.final;
        }
    }

    public showDetailsCmsBlock(name: SHOW_DETAILS_CMS): void {
        this[name] = true;
    }

    public hideDetailsCmsBlock(name: SHOW_DETAILS_CMS): void {
        this[name] = false;
    }

    private getPlanType() {
        switch (this.plan.type_id) {
            case 'plan_ideo':
                return 'ideo';
            case 'plan_ideo_pro':
                return 'ideo_pro';
            case 'plan_sowo':
            case 'plan_sowo_renew':
                return this.plan?.data?.commercial_range === CommercialRange.BYOU ? 'byou' : 'simo';
            default:
                return 'sas';
        }
    }

    private updateLockedStatus(): void {
        const blockedPlans = this.universalStorage.getItem('blockedPlans');
        this.locked = blockedPlans && !!blockedPlans[this.plan.id];
    }

    public updateLockedPlans(): void {
        this.onLockAction.next(this.locked);
    }

    public addToCart(): void {
        this.onAddCart.next(null);
    }

    public sendTags() {
        const scheme = new Scheme(new ProductContext(this.contextService));
        const planItem: Plan = Catalog.getInstance(this.plan.getJsonData(), scheme.productContext) as Plan;
        const promos: string[] = planItem
            .getEligiblePromosList()
            .map((promo: IPromotions) => `${promo.id}_${promo.name}`);

        const planName = this.plan.data.name.replace(/\s/gi, '_');
        this.tagService.send({
            ...this.tagValues,
            parcours: this.isRenew ? 'Renouvellement' : 'Acquisition',
            page: this.ctaLabel ? `Forfait_${planName}` : `Fiche_tel_forfait_${planName}`,
            activiteB2BouB2C: this.isWithoutTax ? 'B2B' : 'B2C',
            produits: [
                {
                    name: this.plan.name,
                    id: this.plan.data.entity_id,
                    gencode: this.plan.gencode,
                    sku: this.plan.sku,
                    price: this.plan.price,
                    ligneProduit_niv1: 'Forfaits_mobile',
                    gamme: PLAN_TAG_NAMES[this.plan.type_id],
                    promo: promos,
                    type_id: this.plan.type_id,
                },
            ],
        });
    }
}
